const V3Annoucement = require('./v3-annoucement')

module.exports = {
  V3Annoucement,
}

